var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 24,
    viewBox: "0 0 16 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.47 6.167a.75.75 0 0 1 1.06 0l5.304 5.303a.75.75 0 0 1 0 1.06L5.53 17.835a.75.75 0 1 1-1.06-1.06L9.243 12 4.47 7.228a.75.75 0 0 1 0-1.061Z",
    fill: "#09205D"
  })));
};

export default SvgArrowRight;